import { Box, Container } from "@mui/material";
import { React, useEffect } from "react";
import Navbar from "./Navbar";
import SideBar from "../SideBar";
import { useLocation, useNavigate } from "react-router-dom";

const Layout = ({ children }) => {
  const location = useLocation().pathname;

  // const [mode, setMode] = useState(
  //   localStorage.getItem("mode") === "dark" ? "dark" : "light"
  // );

  // Toggle between light and dark themes
  // const theme = useMemo(() => {
  //   return mode === "light" ? lightTheme : darkTheme;
  // }, [mode]);

  // const toggleTheme = () => {
  //   const newMode = mode === "light" ? "dark" : "light";
  //   setMode(newMode);
  //   localStorage.setItem("mode", newMode);
  // };

  return (
    <>
      <Box sx={{ position: "sticky", top: 0, zIndex: 1 }}>
        <Navbar />
      </Box>
      <Box
        sx={{
          display: "flex",
          height: "calc(100vh - 64px)",
          backgroundColor: "#FBFBFB",
        }}
      >
        {location !== "/" && (
          <Box
            sx={{
              width: "4%",
            }}
          >
            <SideBar />
          </Box>
        )}
        <Box
          style={{
            maxWidth: "none",
            backgroundColor: "#FBFBFB",
            position: "relative",
            width: "96%",
            height: "100%",
          }}
        >
          {children}
        </Box>
      </Box>
    </>
  );
};

export default Layout;
